<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('contacts')">Bitacora</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>Agregar
    </h1>
    <div v-if="$page.props.auth.user.rol =='Mecanica'" class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="store">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <label class="pr-6 pb-8">Fecha:</label>

          <Datepicker  v-model="form.fecha" :error="form.errors.fecha" class="pr-6 pb-8 w-full lg:w-6/6" format="YYYY-MM-DD H:i:s" required/>

          <select-input v-model="form.conductor_id" :error="form.errors.conductor_id" class="pr-6 pb-8 w-full lg:w-1/3" label="Encargado" required>
            <option v-for="conductor in conductores" :key="conductor.id" :value="conductor.id">{{ conductor.nombres }}  {{ conductor.apellidos}}</option>
        </select-input>
          <text-input v-model="form.maquinaria" :error="form.errors.maquinaria" class="pr-6 pb-8 w-full lg:w-1/3" label="Maquinaria" required/>
          <text-input v-model="form.odometro" :error="form.errors.odometro" class="pr-6 pb-8 w-full lg:w-1/3" label="Odometro" required/>

          <text-input v-model="form.detalle" :error="form.errors.detalle" class="pr-6 pb-8 w-full lg:w-2/2" label="Detalle" required/>
          <text-input v-model="form.lugar" :error="form.errors.lugar" class="pr-6 pb-8 w-full lg:w-1/3" label="Lugar" required/>
          <select-input v-model="form.responsable_id" :error="form.errors.responsable_id" class="pr-6 pb-8 w-full lg:w-1/3" label="Mecánico" required>
            <option v-for="conductor in conductores" :key="conductor.id" :value="conductor.id">{{ conductor.nombres }}  {{ conductor.apellidos}}</option>
        </select-input>
        <select-input v-model="form.tipo" :error="form.errors.tipo" class="pr-6 pb-8 w-full lg:w-1/3" label="Tipo" required>
            <option v-for="tipo in tipos" :key="tipo.id" :value="tipo.id">{{ tipo.tipo }}</option>
        </select-input>
        <select-input v-if="form.tipo==1" v-model="form.subtipo" :error="form.errors.subtipo" class="pr-6 pb-8 w-full lg:w-2/6" label="Subtipo" required>
            <option v-for="subtipo in subtipos1" :key="subtipo.id" :value="subtipo.id">{{ subtipo.subtipo }}</option>
        </select-input>
        <select-input v-if="form.tipo==2" v-model="form.subtipo" :error="form.errors.subtipo" class="pr-6 pb-8 w-full lg:w-2/6" label="Subtipo" required>
            <option v-for="subtipo in subtipos2" :key="subtipo.id" :value="subtipo.id">{{ subtipo.subtipo }}</option>
        </select-input>
        <select-input v-if="form.tipo==3" v-model="form.subtipo" :error="form.errors.subtipo" class="pr-6 pb-8 w-full lg:w-2/6" label="Subtipo" required>
            <option v-for="subtipo in subtipos3" :key="subtipo.id" :value="subtipo.id">{{ subtipo.subtipo }}</option>
        </select-input>
        
        <text-input v-model="form.comentario" :error="form.errors.comentario" class="pr-6 pb-8 w-full lg:w-4/6" label="Comentario" />
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Agregar </loading-button>
        </div>
      </form>
    </div>
<br><br>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Fecha</th>
          <th class="px-6 pt-6 pb-4">Detalle</th>
          <th class="px-6 pt-6 pb-4">Maquinaria</th>
          <th class="px-6 pt-6 pb-4">Lugar</th>
          <th class="px-6 pt-6 pb-4">KM / Horas</th>
          <th class="px-6 pt-6 pb-4">Responsable</th>
          <th class="px-6 pt-6 pb-4">Mecánico</th>
          <th class="px-6 pt-6 pb-4">Tipo</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Comentario</th>
        </tr>
        <tr v-for="contact in bitacoras" :key="contact.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('contacts.edit', contact.id)" tabindex="-1">
              {{ contact.fecha }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('contacts.edit', contact.id)">
              {{ contact.detalle }}
              <icon v-if="contact.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
           <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('contacts.edit', contact.id)">
              {{ contact.activo }}
              <icon v-if="contact.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('contacts.edit', contact.id)" tabindex="-1">
                {{ contact.lugar }}
            </inertia-link>
          </td>
         
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('contacts.edit', contact.id)" tabindex="-1">
              {{ contact.odometro }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('contacts.edit', contact.id)" tabindex="-1">
              {{ contact.encargado }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('contacts.edit', contact.id)" tabindex="-1">
              {{ contact.responsable }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('contacts.edit', contact.id)" tabindex="-1">
              {{ contact.tipo }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('contacts.edit', contact.id)" tabindex="-1">
              {{ contact.comentarios }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('contacts.edit', contact.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="bitacoras.length === 0">
          <td class="border-t px-6 py-4" colspan="4">No Encontramos Bitacoras</td>
        </tr>
      </table>
    </div><br><br>
    <button v-if="$page.props.auth.user.rol !='Cliente'" class="btn-indigo ml-auto" tabindex="-1" type="button" @click="exportarExcel">Exportar Bitacora</button>

  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Datepicker from 'vuejs-datetimepicker'


export default {
  metaInfo: { title: 'Add Bitacora' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    Datepicker
  },
  layout: Layout,
  props: {
    conductores: Array,
    maquinaria: Object,
    bitacoras: Array,
    tipos: Array,
    subtipos1: Array,
    subtipos2: Array,
    subtipos3: Array,



  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        fecha: null,
        detalle: null,
        lugar: null,
        odometro: null,
        responsable_id: null,
        tipo: null,
        subtipo: null,
        comentario: null,
        conductor_id: null,
        maquinaria: this.maquinaria.clase +' '+this.maquinaria.placas,
        maquinaria_id: this.maquinaria.id,
        placa: this.maquinaria.placas,
        clase: this.maquinaria.clase
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('bitacoras.store'))
    },
    exportarExcel() {
        this.$inertia.get(this.route('bitacoras.indexR', this.maquinaria.id))
    },
  },
}
</script>
